import { usageTypeMap } from '@/common/constants';
import { computedPbxPlans } from '@/common/service/computers/plans/pbx';
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['addressInfo', 'getSelectedPlans', 'withCcAccount']),
    hasZPPlan() {
      return !!computedPbxPlans(this.getSelectedPlans).length;
    },
  },
  methods: {
    initFormUsageType(){
      if (this.addressInfo.usageType) {
        return this.addressInfo.usageType;
      }
      if (this.hasZPPlan) {
        return usageTypeMap.business;
      }
      if (this.withCcAccount) {
        return this.addressInfo.usageType || usageTypeMap.personal;
      }
      return usageTypeMap.blank;
    }
  },
};
